import {
  Dialog,
  DialogActionsWrapper,
} from "@/design-system/components/Dialog/Dialog";
import { Button } from "@/design-system/components/Button/Button";

import { Invite } from "@/components/users/types";

type DeleteInviteModalProps = {
  open: boolean;
  invite: Invite | null;
  onClose: () => void;
  onDelete: () => void;
};

function DeleteInviteModal({
  open,
  invite,
  onClose,
  onDelete,
}: DeleteInviteModalProps) {
  const userString = invite ? invite.to_email : "this user";

  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
      open={open}
      title="Delete teammate invite"
    >
      <p className="text-sm">
        <span>
          Are you sure you want to delete the invitation for <b>{userString}</b>{" "}
          from your account?
        </span>
      </p>
      <DialogActionsWrapper>
        <Button variant="ghost" onClick={onClose}>
          Close
        </Button>
        <Button onClick={onDelete} variant="destructive">
          Delete user invite
        </Button>
      </DialogActionsWrapper>
    </Dialog>
  );
}

export default DeleteInviteModal;
